import {articles, minmax} from './shared.js';
import {ticker} from './ticker.js';

const ch9 = articles.find(article => article.dataset.chapter === '9');
export const nav = document.querySelector('#app-nav');
const svg = nav.querySelector('svg');
const chapters = Array.from(svg.querySelectorAll('.chapter'));

const mapChapterToArticle = new Map(chapters.map(chapter => {
  return [chapter, document.querySelector(`#chapter${/nav-chapter(\d+)/.exec(chapter.id)[1]}`)];
}));

const mapChapterToTimeline = new Map();

/**
 * Jump to a chapter article
 * @param {DOMNode} article article
 * @param {Number} offset offset from top of article
 * @return {Promise} resolves with onComplete event
 */
export function jumpToChapter(article, offset) {
  if (isNaN(offset)) {
    offset = window.innerHeight / 2;
  }
  return new Promise(resolve => {
    TweenLite.set(window, {scrollTo: article.offsetTop + offset, onComplete: () => resolve()});
  });
}

/**
 * Jump to a chapter article plus an offset
 * @param {DOMNode} article article
 * @param {Number} offset offset
 * @return {Promise} resolves when complete
 */
export function jumpToChapterOffset(article, offset) {
  return new Promise(resolve => TweenLite.set(window, {scrollTo: article.offsetTop + offset, onComplete: resolve}));
}

// clicking on a chapter takes the user to the article
svg.addEventListener('click', ({clientY: y}) => {
  for (const chapter of chapters) {
    const {top, bottom} = chapter.getBoundingClientRect();
    if (y >= top && y <= bottom) {
      const article = mapChapterToArticle.get(chapter);
      const n = +article.dataset.chapter;
      if (n === 1) {
        jumpToChapterOffset(article, 1);
      } else if (n === 9) {
        console.log('ch9');
        jumpToChapterOffset(article, window.innerHeight * 1.75);
      } else {
        jumpToChapter(article);
      }
      return;
    }
  }
});

for (const chapter of chapters) {
  const timeline = new TimelineLite({paused: true});

  mapChapterToTimeline.set(chapter, timeline);

  // pad beginning/end of timeline for animation 'breathing room'
  timeline.to({}, 0.1, {});

  const timePaths = chapter.querySelectorAll('.time');

  for (const path of timePaths) {
    const len = path.getTotalLength();
    TweenLite.set(path, {attr: {'stroke-dasharray': `${len} ${len}`, 'stroke-dashoffset': len}});
    timeline.to(path, 100, {attr: {'stroke-dashoffset': 0}});
  }

  // pad beginning/end of timeline for animation 'breathing room'
  timeline.to({}, 0.1, {});
}

window.addEventListener('scroll', () => {
  for (const chapter of chapters) {
    const article = mapChapterToArticle.get(chapter);
    const last = article.matches(':nth-last-of-type(1)');
    const timeline = mapChapterToTimeline.get(chapter);
    let percent;

    if (!last) {
      percent = 1.0 - minmax(0, article.offsetTop - window.pageYOffset + article.scrollHeight, article.scrollHeight) / article.scrollHeight;
    } else {
      percent = 1.0 - minmax(0, article.offsetTop - window.pageYOffset + article.scrollHeight - window.innerHeight, article.scrollHeight - window.innerHeight) / (article.scrollHeight - window.innerHeight);
    }

    timeline.progress(percent);
  }

  if (window.pageYOffset >= ch9.offsetTop) {
    nav.classList.add('no-first-half');

    if (window.pageYOffset <= ch9.offsetTop + ch9.scrollHeight) {
      nav.classList.add('middle');
    } else {
      nav.classList.remove('middle');
    }
  } else {
    nav.classList.remove('no-first-half');
    nav.classList.remove('middle');
  }

  let article = articles.find(article => window.pageYOffset >= article.offsetTop && window.pageYOffset < article.offsetTop + article.scrollHeight);

  if (article) {
    ticker.dataset.chapter = article.dataset.chapter;
  }
}, {passive: true});

// the last article is special because it reaches 100% when the article bottom crosses the bottom of the viewport,
// unlike other articles, which reach 100% when the article bottom crosses the top of the viewport.
//
// therefore, extend the timeline of the last article to compensate, so that it reaches 100% when one viewport
// height of scrolling remains.
/*
{
  const lastChapter = chapters.find(chapter => chapter.id === 'nav-chapter19');
  const lastArticle = mapChapterToArticle.get(lastChapter);
  const lastChapterTimeline = mapChapterToTimeline.get(lastChapter);
  const lastScreenFrac = window.innerHeight / lastArticle.scrollHeight;
  const extraTime = lastChapterTimeline.duration() / lastScreenFrac;
  lastChapterTimeline.to({}, extraTime, {});
}
*/
